<template>
  <div class="page-box" style="position: relative;">
    <el-form ref="integralRecordFilter" :model="integralRecord" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350"
        @search="refreshIntegralRecord(true)"
        @reset="onResetIntegralRecord"
      >
        <el-form-item label="创建时间" prop="formFilter.createTime">
<!--          <el-date-picker class="filter-item" v-model="integralRecord.formFilter.createTime" :clearable="true"-->
<!--            format="yyyy-MM-dd"-->
<!--            value-format="yyyy-MM-dd 00:00:00"-->
<!--            type="date" align="left"-->
<!--            placeholder="创建时间"-->
<!--          />-->
          <date-range class="filter-item" v-model="integralRecord.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                      format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="专家名称" prop="formFilter.specialistName">
          <el-input class="filter-item" v-model="integralRecord.formFilter.specialistName"
            :clearable="true" placeholder="专家名称"
          />

        </el-form-item>
        <el-form-item label="人员类型" prop="formFilter.createType">
          <el-select class="filter-item" v-model="integralRecord.formFilter.createType" :clearable="true" filterable
                     placeholder="人员类型" :loading="integralRecord.createType.impl.loading"
                     @visible-change="integralRecord.createType.impl.onVisibleChange"
          >
            <el-option v-for="item in integralRecord.createType.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
<!--        <el-form-item label="积分详情" prop="formFilter.integralDesc">-->
<!--          <el-input class="filter-item" v-model="integralRecord.formFilter.integralDesc"-->
<!--            :clearable="true" placeholder="积分详情"-->
<!--          />-->
<!--        </el-form-item>-->
        <el-form-item label="积分类型" prop="formFilter.integralType">
          <el-select class="filter-item" v-model="integralRecord.formFilter.integralType" :clearable="true" filterable
                     placeholder="" :loading="integralRecord.integralType.impl.loading"
                     @visible-change="integralRecord.integralType.impl.onVisibleChange"
                     >
            <el-option v-for="item in integralRecord.integralType.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetIntegralRecord">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshIntegralRecord(true)">查询
        </el-button>
      </filter-box>
    </el-form>
<!--      <table-box ref="integralRecord"-->
<!--        :data="integralRecord.IntegralRecord.impl.dataList" :size="defaultFormItemSize"-->
<!--        :row-config="{isCurrent: false, isHover: true}"-->
<!--        :seq-config="{startIndex: ((integralRecord.IntegralRecord.impl.currentPage - 1) * integralRecord.IntegralRecord.impl.pageSize)}"-->
<!--        :sort-config="{remote: true}" :hasExtend="false"-->
<!--        @sort-change="integralRecord.IntegralRecord.impl.onSortChange"-->
<!--        @refresh="refreshIntegralRecord(true)"-->
<!--      >-->
<!--        &lt;!&ndash; 表格操作 &ndash;&gt;-->
<!--        &lt;!&ndash; 表格列 &ndash;&gt;-->
<!--        <vxe-column title="序号" type="seq" width="50px" :index="integralRecord.IntegralRecord.impl.getTableIndex" />-->
<!--        <vxe-column title="创建时间" field="createTime">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>-->
<!--          </template>-->
<!--        </vxe-column>-->
<!--        <vxe-column title="专家名称" field="specialistName" />-->
<!--        <vxe-column title="积分类型" field="integralTypeDictMap.name">-->
<!--        </vxe-column>-->
<!--        <vxe-column title="积分详情" field="integralDesc" />-->
<!--        <vxe-column title="积分" field="integral" />-->
<!--        <vxe-column title="操作类型" field="opreationType" />-->
<!--        <template slot="empty">-->
<!--          <div class="table-empty unified-font">-->
<!--            <img src="@/assets/img/empty.png">-->
<!--            <span>暂无数据</span>-->
<!--          </div>-->
<!--        </template>-->
<!--    <el-row>-->
      <p v-if="yearIntegral">年度积分：{{yearIntegral}} </p>

<!--    </el-row>-->

    <el-table ref="integralRecord" :data="integralRecord.IntegralRecord.impl.dataList" :size="defaultFormItemSize" @sort-change="integralRecord.IntegralRecord.impl.onSortChange"
              header-cell-class-name="table-header-gray"
              @selection-change="onIntegralRecordSelectionChange"
    >
      <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="integralRecord.IntegralRecord.impl.getTableIndex" />
      <!--          <el-table-column type="selection"-->
      <!--            header-align="center" align="center" width="55px"-->
      <!--          />-->
      <el-table-column label="获得者" >
        <template slot-scope="scope">
          <span v-if="scope.row.specialistName">{{scope.row.specialistName}}</span>
          <span v-else>{{scope.row.createUserIdDictMap.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="积分类型" prop="integralTypeDictMap.name">
      </el-table-column>
      <el-table-column label="积分详情" prop="integralDesc">
      </el-table-column>
      <el-table-column label="积分" prop="integral">
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime">
      </el-table-column>
<!--      <el-table-column label="操作类型" prop="operationType"></el-table-column>-->

    </el-table>

        <!-- 分页 -->
        <el-row slot="pagination" type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="integralRecord.IntegralRecord.impl.totalCount"
            :current-page="integralRecord.IntegralRecord.impl.currentPage"
            :page-size="integralRecord.IntegralRecord.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="integralRecord.IntegralRecord.impl.onCurrentPageChange"
            @size-change="integralRecord.IntegralRecord.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
<!--      </table-box>-->
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { IntegralRecordController, DictionaryController } from '@/api';

export default {
  name: 'integralRecord',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      yearIntegral: undefined,
      integralRecord: {
        formFilter: {
          createTime: undefined,
          specialistName: undefined,
          integralDesc: undefined,
          integralType: undefined,
          createType: undefined
        },
        formFilterCopy: {
          createTime: undefined,
          specialistName: undefined,
          integralDesc: undefined,
          integralType: undefined,
          createType: undefined
        },
        IntegralRecord: {
          deleteRows: [],
          impl: new TableWidget(this.loadIntegralRecordWidgetData, this.loadIntegralRecordVerify, true, false, 'createTime', 1)
        },
        integralType: {
          impl: new DropdownWidget(this.loadIntegralTypeDropdownList)
        },
        createType: {
          impl: new DropdownWidget(this.loadCreateTypeDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetIntegralRecord () {
      this.$refs.integralRecordFilter.resetFields();
      this.refreshIntegralRecord(true);
    },
    /**
     * 积分记录数据获取函数，返回Promise
     */
    loadIntegralRecordWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        integralRecordDtoFilter: {
          createTimeStart: Array.isArray(this.integralRecord.formFilterCopy.createTime) ? this.integralRecord.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.integralRecord.formFilterCopy.createTime) ? this.integralRecord.formFilterCopy.createTime[1] : undefined,
          specialistName: this.integralRecord.formFilterCopy.specialistName,
          integralDesc: this.integralRecord.formFilterCopy.integralDesc,
          integralType: this.integralRecord.formFilterCopy.integralType,
          createType: this.integralRecord.formFilterCopy.createType
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        IntegralRecordController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 积分记录数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadIntegralRecordVerify () {
      this.integralRecord.formFilterCopy.createTime = this.integralRecord.formFilter.createTime;
      this.integralRecord.formFilterCopy.specialistName = this.integralRecord.formFilter.specialistName;
      this.integralRecord.formFilterCopy.integralDesc = this.integralRecord.formFilter.integralDesc;
      this.integralRecord.formFilterCopy.integralType = this.integralRecord.formFilter.integralType;
      this.integralRecord.formFilterCopy.createType = this.integralRecord.formFilter.createType;
      return true;
    },
    onIntegralRecordSelectionChange (values) {
      this.integralRecord.IntegralRecord.deleteRows = (values || []).map(item => {
        return item.id;
      });
    },
    /**
     * 更新积分记录
     */
    refreshIntegralRecord (reloadData = false) {
      if (reloadData) {
        this.integralRecord.IntegralRecord.impl.refreshTable(true, 1);
      } else {
        this.integralRecord.IntegralRecord.impl.refreshTable();
      }
      if (!this.integralRecord.isInit) {
        // 初始化下拉数据
      }
      this.integralRecord.isInit = true;
    },
    loadIntegralTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIntegralType(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadCreateTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictCreateTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    getYearIntegral () {
      IntegralRecordController.yearIntegral(this, {}).then(res => {
        this.yearIntegral = res.data
      })
    },
    onResume () {
      this.refreshIntegralRecord();
    },
    initFormData () {
    },
    formInit () {
      this.refreshIntegralRecord();
      this.getYearIntegral()
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
